import React, { useContext, useState } from 'react'
import './SideBar.scss'
import CloseCross from '../../assets/images/closeCross'
import { VersionHistoryContext } from '../../context/versionHistoryContext'
import { SideBarOptions } from './SideBarOptions'


const SkeletonContainer = () => {
  return (
    <>
      <div className='skeleton-container'>
        <Skeleton width="200px" height="20px" />
        <Skeleton width="100%" height="50px" />
        <Skeleton width="100%" height="50px" />
      </div>
      <div className='skeleton-container'>
        <Skeleton width="200px" height="20px" />
        <Skeleton width="100%" height="50px" />
      </div>
    </>
  )
}

const Skeleton = ({ width, height }) => (
  <div className="skeleton" style={{ width, height }}></div>
);

const GroupVersion = ({ versions, groupID, category, showMore, setShowMore }) => {
  const { state, actions } = useContext(VersionHistoryContext);
  const isShowMore = showMore === versions[0].version_id;

  const handleShowMoreVersions = (versionID) => {
    if (showMore === versionID) {
      setShowMore(null);
    } else {
      setShowMore(versionID)
    }
  }

  const handleSelectVersion = (versionID) => {
    if (state.selectedVersion.version_id !== versionID) {
      actions.selectVersion(category, groupID, versionID);
    }
  }

  return (
    <div className='group-version'>
      <div className='parent-version'>
        <VersionLabel
          date={versions[0].formatedDate}
          isCurrentVersion={versions[0].versionNumber === 1}
          isSelected={state.selectedVersion.version_id === versions[0].version_id}
          onClick={() => {
            handleShowMoreVersions(versions[0].version_id);
            handleSelectVersion(versions[0].version_id)
          }}
          showMoreIcon={versions.length > 1}
          showMore={isShowMore}
        />
      </div>
      <div className={`child-version ${isShowMore ? "active" : ""}`}>
        {isShowMore && versions.length > 1 && versions.slice(1).map((version, i) =>
          <VersionLabel
            key={i}
            date={version.formatedDate}
            isCurrentVersion={version.versionNumber === 1}
            isSelected={state.selectedVersion.version_id === version.version_id}
            onClick={() => handleSelectVersion(version.version_id)}
          />
        )}
      </div>
    </div>
  )
}

const VersionLabel = ({ date, isSelected, isCurrentVersion, onClick, showMoreIcon, showMore }) => {
  return (
    <div className={`versionLabel ${isSelected ? "selected" : ""}`} onClick={onClick}>
      <div>
        <span>
          {
            showMoreIcon && <div><span className={`arrow ${showMore ? "active" : ""}`}><span></span><span></span></span></div>
          }
          {date}
        </span>
        {isCurrentVersion && <span className='current'>Current Version</span>}
      </div>
      {isSelected && <SideBarOptions />
      }
    </div>
  )
}

export const SideBar = () => {
  const { state, actions } = useContext(VersionHistoryContext);
  const [showMore, setShowMore] = useState(null);

  const handleOnClose = () => {
    actions.closeVersionHistory();
  }

  return (
    <div className='history-sidebar'>
      <div className='history-sidebar-title'>
        <span>Version History</span>
        <CloseCross width="12" onClick={handleOnClose} />
      </div>
      <div className='history-sidebar-content'>
        {
          state.isLoading ?
            <SkeletonContainer />
            :
            Object.keys(actions.getHistory()).length ?
              Object.entries(actions.getHistory()).map(([category, groups], index) => (
                <div key={index}>
                  <div className='versionCategory'>{category}</div>
                  {groups.map((group, i) => (
                    <GroupVersion
                      key={i}
                      versions={group}
                      groupID={i}
                      category={category}
                      showMore={showMore}
                      setShowMore={setShowMore}
                    />
                  ))}
                </div>
              ))
              :
              <div className='error'>There are no versions available</div>
        }
      </div>
    </div>
  )
}
